/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AdminMealMultiLangResponse } from '../model';
// @ts-ignore
import { CreateMealPortionRequest } from '../model';
// @ts-ignore
import { CreateMealRequest } from '../model';
// @ts-ignore
import { MealBriefResponse } from '../model';
// @ts-ignore
import { PagedResponseAdminMealMultiLangResponse } from '../model';
// @ts-ignore
import { UpdateMealRequest } from '../model';
/**
 * AdminMealControllerApi - axios parameter creator
 * @export
 */
export const AdminMealControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateMealRequest} createMealRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMeal: async (createMealRequest: CreateMealRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createMealRequest' is not null or undefined
            assertParamExists('createMeal', 'createMealRequest', createMealRequest)
            const localVarPath = `/admin/meals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMealRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mealId 
         * @param {CreateMealPortionRequest} createMealPortionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMealPortion: async (mealId: string, createMealPortionRequest: CreateMealPortionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mealId' is not null or undefined
            assertParamExists('createMealPortion', 'mealId', mealId)
            // verify required parameter 'createMealPortionRequest' is not null or undefined
            assertParamExists('createMealPortion', 'createMealPortionRequest', createMealPortionRequest)
            const localVarPath = `/admin/meals/{mealId}/portions`
                .replace(`{${"mealId"}}`, encodeURIComponent(String(mealId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMealPortionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMeal: async (mealId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mealId' is not null or undefined
            assertParamExists('deleteMeal', 'mealId', mealId)
            const localVarPath = `/admin/meals/{mealId}`
                .replace(`{${"mealId"}}`, encodeURIComponent(String(mealId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeal: async (mealId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mealId' is not null or undefined
            assertParamExists('getMeal', 'mealId', mealId)
            const localVarPath = `/admin/meals/{mealId}`
                .replace(`{${"mealId"}}`, encodeURIComponent(String(mealId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBriefMeals: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/meals/brief`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMeals: async (search?: string, page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/meals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mealId 
         * @param {UpdateMealRequest} updateMealRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMeal: async (mealId: string, updateMealRequest: UpdateMealRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mealId' is not null or undefined
            assertParamExists('updateMeal', 'mealId', mealId)
            // verify required parameter 'updateMealRequest' is not null or undefined
            assertParamExists('updateMeal', 'updateMealRequest', updateMealRequest)
            const localVarPath = `/admin/meals/{mealId}`
                .replace(`{${"mealId"}}`, encodeURIComponent(String(mealId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMealRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminMealControllerApi - functional programming interface
 * @export
 */
export const AdminMealControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminMealControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateMealRequest} createMealRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMeal(createMealRequest: CreateMealRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMeal(createMealRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} mealId 
         * @param {CreateMealPortionRequest} createMealPortionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMealPortion(mealId: string, createMealPortionRequest: CreateMealPortionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMealPortion(mealId, createMealPortionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} mealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMeal(mealId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMeal(mealId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} mealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeal(mealId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminMealMultiLangResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeal(mealId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBriefMeals(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MealBriefResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBriefMeals(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMeals(search?: string, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResponseAdminMealMultiLangResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMeals(search, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} mealId 
         * @param {UpdateMealRequest} updateMealRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMeal(mealId: string, updateMealRequest: UpdateMealRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMeal(mealId, updateMealRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminMealControllerApi - factory interface
 * @export
 */
export const AdminMealControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminMealControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateMealRequest} createMealRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMeal(createMealRequest: CreateMealRequest, options?: any): AxiosPromise<void> {
            return localVarFp.createMeal(createMealRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} mealId 
         * @param {CreateMealPortionRequest} createMealPortionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMealPortion(mealId: string, createMealPortionRequest: CreateMealPortionRequest, options?: any): AxiosPromise<void> {
            return localVarFp.createMealPortion(mealId, createMealPortionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} mealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMeal(mealId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteMeal(mealId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} mealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeal(mealId: string, options?: any): AxiosPromise<AdminMealMultiLangResponse> {
            return localVarFp.getMeal(mealId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBriefMeals(options?: any): AxiosPromise<Array<MealBriefResponse>> {
            return localVarFp.listBriefMeals(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMeals(search?: string, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PagedResponseAdminMealMultiLangResponse> {
            return localVarFp.listMeals(search, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} mealId 
         * @param {UpdateMealRequest} updateMealRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMeal(mealId: string, updateMealRequest: UpdateMealRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateMeal(mealId, updateMealRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminMealControllerApi - object-oriented interface
 * @export
 * @class AdminMealControllerApi
 * @extends {BaseAPI}
 */
export class AdminMealControllerApi extends BaseAPI {
    /**
     * 
     * @param {CreateMealRequest} createMealRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMealControllerApi
     */
    public createMeal(createMealRequest: CreateMealRequest, options?: AxiosRequestConfig) {
        return AdminMealControllerApiFp(this.configuration).createMeal(createMealRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} mealId 
     * @param {CreateMealPortionRequest} createMealPortionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMealControllerApi
     */
    public createMealPortion(mealId: string, createMealPortionRequest: CreateMealPortionRequest, options?: AxiosRequestConfig) {
        return AdminMealControllerApiFp(this.configuration).createMealPortion(mealId, createMealPortionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} mealId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMealControllerApi
     */
    public deleteMeal(mealId: string, options?: AxiosRequestConfig) {
        return AdminMealControllerApiFp(this.configuration).deleteMeal(mealId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} mealId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMealControllerApi
     */
    public getMeal(mealId: string, options?: AxiosRequestConfig) {
        return AdminMealControllerApiFp(this.configuration).getMeal(mealId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMealControllerApi
     */
    public listBriefMeals(options?: AxiosRequestConfig) {
        return AdminMealControllerApiFp(this.configuration).listBriefMeals(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMealControllerApi
     */
    public listMeals(search?: string, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return AdminMealControllerApiFp(this.configuration).listMeals(search, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} mealId 
     * @param {UpdateMealRequest} updateMealRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMealControllerApi
     */
    public updateMeal(mealId: string, updateMealRequest: UpdateMealRequest, options?: AxiosRequestConfig) {
        return AdminMealControllerApiFp(this.configuration).updateMeal(mealId, updateMealRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

